import {
  IconBrandOpenai,
  IconBrandMeta,
  IconBrandAmazon,
  IconBrandGoogleFilled,
} from '@tabler/icons-react'

import PerplexityLogo from 'src/components/Logos/PerplexityLogo'
import AnthropicLogo from 'src/components/Threads/Providers/AnthropicLogo'

export const PROVIDER_LOGOS = {
  Anthropic: AnthropicLogo,
  Google: IconBrandGoogleFilled,
  OpenAI: IconBrandOpenai,
  Perplexity: PerplexityLogo,
  Meta: IconBrandMeta,
  Amazon: IconBrandAmazon,
}

export const PROVIDER_COLORS = {
  Anthropic: 'primary.main',
  Google: '#4285F4',
  OpenAI: 'primary.main',
  Perplexity: null,
  Meta: '#0081FB',
  Amazon: '#FF9900',
}

export const AVAILABLE_MODELS = {
  'us.anthropic.claude-opus-4-20250514-v1:0': {
    name: 'Claude Opus 4',
    description: 'Highly capable, complex tasks',
    thinkingMode: 'optional',
    provider: 'Anthropic',
    additionalSystemPrompt: '',
    tokenLimit: 200000,
  },
  'us.anthropic.claude-sonnet-4-20250514-v1:0': {
    name: 'Claude Sonnet 4',
    description: 'Enhanced, efficient writing',
    thinkingMode: 'optional',
    provider: 'Anthropic',
    additionalSystemPrompt: '',
    tokenLimit: 200000,
  },
  'us.anthropic.claude-3-7-sonnet-20250219-v1:0': {
    name: 'Claude 3.7 Sonnet',
    description: 'Analytical, meticulous, insightful',
    thinkingMode: 'optional',
    provider: 'Anthropic',
    additionalSystemPrompt: '',
    tokenLimit: 200000,
  },
  'us.anthropic.claude-3-5-sonnet-20241022-v2:0': {
    name: 'Claude 3.5 Sonnet',
    description: 'Reliable, concise, creative',
    thinkingMode: 'disabled',
    provider: 'Anthropic',
    additionalSystemPrompt: '',
    tokenLimit: 200000,
  },
  'gemini-2.0-flash': {
    name: 'Gemini 2.0 Flash',
    description: 'Fast, simpler tasks',
    thinkingMode: 'disabled',
    provider: 'Google',
    additionalSystemPrompt:
      'Never respond with ```html, just respond with the inner html content. Remember you have access to tools.',
    tokenLimit: 1048576,
  },
  'gemini-2.5-pro-preview-03-25': {
    name: 'Gemini 2.5 Pro Preview',
    description: 'Powerful, limited preview',
    thinkingMode: 'required',
    provider: 'Google',
    additionalSystemPrompt: '',
    tokenLimit: 1048576,
  },
  'us.anthropic.claude-3-5-haiku-20241022-v1:0': {
    name: 'Claude 3.5 Haiku',
    description: 'Fast, efficient, lightweight',
    thinkingMode: 'disabled',
    provider: 'Anthropic',
    additionalSystemPrompt: '',
    tokenLimit: 200000,
  },
  'gpt-4o': {
    name: 'GPT-4 Omni',
    description: 'Multimodal, highly capable',
    thinkingMode: 'disabled',
    provider: 'OpenAI',
    additionalSystemPrompt: '',
    tokenLimit: 128000,
  },
  'gpt-4o-mini': {
    name: 'GPT-4 Omni Mini',
    description: 'Fast, cost-effective',
    thinkingMode: 'disabled',
    provider: 'OpenAI',
    additionalSystemPrompt: '',
    tokenLimit: 128000,
  },
  'o4-mini-2025-04-16': {
    name: 'O4 Mini',
    description: 'Advanced reasoning, efficient',
    thinkingMode: 'disabled',
    provider: 'OpenAI',
    additionalSystemPrompt: '',
    tokenLimit: 200000,
  },
  sonar: {
    name: 'Sonar',
    description: 'Web search, basic',
    thinkingMode: 'disabled',
    provider: 'Perplexity',
    additionalSystemPrompt: '',
    tokenLimit: 127072,
  },
  'sonar-pro': {
    name: 'Sonar Pro',
    description: 'Web search, enhanced',
    thinkingMode: 'disabled',
    provider: 'Perplexity',
    additionalSystemPrompt: '',
    tokenLimit: 127072,
  },
  'sonar-reasoning-pro': {
    name: 'Sonar Reasoning Pro',
    description: 'Web search, deep reasoning',
    thinkingMode: 'disabled',
    provider: 'Perplexity',
    additionalSystemPrompt: '',
    tokenLimit: 127072,
  },
  'us.meta.llama3-3-70b-instruct-v1:0': {
    name: 'Llama 3.3 70B Instruct',
    description: 'Fast, efficient open model',
    thinkingMode: 'disabled',
    provider: 'Meta',
    additionalSystemPrompt: '',
    tokenLimit: 128000,
  },
  'amazon.nova-pro-v1:0': {
    name: 'Amazon Nova Pro',
    description: 'Large context, multimodal',
    thinkingMode: 'disabled',
    provider: 'Amazon',
    additionalSystemPrompt: '',
    tokenLimit: 300000,
  },
} as const

export type AvailableModelId = keyof typeof AVAILABLE_MODELS

export const DEFAULT_MODEL_ID: AvailableModelId =
  'us.anthropic.claude-sonnet-4-20250514-v1:0'
